export default __webpack_public_path__ + "img/logo.46bb844f.jpg";